import { isDefined } from "@clipboard-health/util-ts";
import { differenceInMinutes } from "date-fns";
import pluralize from "pluralize";

import { type ChartingNoncompliance } from "../api/schema";
import { chartingDeadlineHasPassed } from "./helpers";

export function getTimeUntilDeactivationDisplayText(deadlineToChart: Date) {
  const now = new Date();
  const minutesUntilDeactivation = differenceInMinutes(deadlineToChart, now);

  if (minutesUntilDeactivation > 60) {
    const hoursUntilDeactivation = Math.floor(minutesUntilDeactivation / 60);
    return `${hoursUntilDeactivation} ${pluralize("hour", hoursUntilDeactivation)}`;
  }

  return `less than an hour`;
}

export function getOnHoldCalloutDisplayText(deadlineToChart: Date) {
  if (chartingDeadlineHasPassed(deadlineToChart)) {
    return "You have incomplete charting";
  }

  return `You have ${getTimeUntilDeactivationDisplayText(deadlineToChart)} to make up charting`;
}

export function getChartingNoteDisplayText(
  chartingNoncompliance: ChartingNoncompliance
): string | undefined {
  const {
    attributes: { chartingStatus, incompleteChartingNotes, completionPercentage },
  } = chartingNoncompliance;

  if (chartingStatus === "not_started" || completionPercentage === 0) {
    return "Charting was not started";
  }

  if (isDefined(incompleteChartingNotes)) {
    return incompleteChartingNotes;
  }

  return undefined;
}
